import { AppDispatch } from "../../../../setup/Store";
import {
  IAgentEmailOTPRequest,
  IAgentLoginRequest,
  IAgentPhoneOTPRequest,
  IAgentSubmitOTPRequest,
} from "../models/request";
import * as requestApi from "./AuthCRUD";
import { authSlice } from "./AuthSlice";

const { actions } = authSlice;

export const agentLogin =
  (data: IAgentLoginRequest) => (dispatch: AppDispatch) =>
    dispatch(requestApi.agentLogin(data)).then((res) => res?.payload);

export const agentRequestEmailOTP =
  (data: IAgentEmailOTPRequest) => (dispatch: AppDispatch) =>
    dispatch(requestApi.agentRequestEmailOTP(data)).then((res) => res?.payload);

export const agentRequestPhoneOTP =
  (data: IAgentPhoneOTPRequest) => (dispatch: AppDispatch) =>
    dispatch(requestApi.agentRequestPhoneOTP(data)).then((res) => res?.payload);

export const agentSubmitOTP =
  (data: IAgentSubmitOTPRequest) => (dispatch: AppDispatch) =>
    dispatch(requestApi.agentSubmitOTP(data)).then((res) => res?.payload);
